import { BillingCounts } from '@ninety/platform/models/billing/billing-counts-response';
import { Invoice } from '@ninety/platform/models/billing/invoice';
import { PricingPlan } from '@ninety/platform/models/billing/pricing-plan';
import { SubscriptionConfigurationV3 } from '@ninety/platform/models/billing/subscription-configuration-v3';
import { SubscriptionConfiguration } from '@ninety/platform/models/billingv2/subscription-configuration.model';

export interface BillingState {
  subscriptionConfigurations: SubscriptionConfiguration[];
  companyBillingCounts: BillingCounts;
  upcomingInvoice?: Invoice;

  /** Billing V3 (commercial model) */
  pricingPlans: PricingPlan[];
  currentSubscriptionConfig: SubscriptionConfigurationV3;

  /** subscription config company will be downgraded to after billing period */
  futureSubscriptionConfig?: SubscriptionConfigurationV3;
  upgradedSuccessfully?: boolean;
}

export const InitialBillingState: BillingState = {
  subscriptionConfigurations: [],
  companyBillingCounts: {} as BillingCounts,
  upcomingInvoice: {} as Invoice,

  /** Billing V3 (commercial model) */
  pricingPlans: null,
  currentSubscriptionConfig: null,
  futureSubscriptionConfig: null,
  upgradedSuccessfully: false,
};
